import { type DataSourceAbstract, type RecordPoint } from '@lighthouse/core'
import React, { createContext, useContext } from 'react'

interface FieldSelectTableContextInterface {
    dsId: string
    recordPoints: RecordPoint[]
    value: string[]
    loading: boolean
    datasourceList?: DataSourceAbstract[]
    children?: React.ReactNode

    onRowClick?: (id: string) => void
}

const FieldSelectTableContext = createContext<FieldSelectTableContextInterface>({
    dsId: '',
    recordPoints: [],
    loading: false,
    value: []
})

export const FieldSelectTableContextProvider = ({ children, ...rest }: FieldSelectTableContextInterface) => {
    return <FieldSelectTableContext.Provider value={rest}>{children}</FieldSelectTableContext.Provider>
}

export const useFieldSelectTableContext = () => useContext(FieldSelectTableContext)
